module.exports = __webpack_public_path__ + "static/media/step1-poster.358352ad.png";